<app-inksofteditor *ngIf="!success"></app-inksofteditor>
